<div class="rounded-full cursor-default w-fit py-1 px-2 gap-2 flex items-center justify-between bg-{{ color }}-500 text-{{ textColor }}" [ngClass]="{ 'gap-1': small, 'text-sm': small, 'w-full': fullWidth }" [matTooltip]="tooltip">
    <mat-icon *ngIf="icon" class="text-{{textColor}} m-0" [class.text-xl]="small">{{icon}}</mat-icon>
    {{ content }}
</div>
